// extracted by mini-css-extract-plugin
export default {"VisuallyHidden":"VisuallyHidden-module__VisuallyHidden___3elg7"};